import React from 'react'
import './Preview.css'
import {RiCloseLine} from 'react-icons/ri'

function Preview(props) {
    const {preview, setPreview} = props

  return (
    <div className='preview-container'>
        <div className='preview'>
            <div style={{width:'60%'}}>
                <img src="https://wallpapercave.com/wp/Mn9KEYe.jpg" className='photo-image' />
            </div>
            <div style={{width:'40%',padding:'1vh 1vw'}}>
                <div style={{cursor:'pointer',textAlign:'right'}} onClick={()=>setPreview(!preview)}>
                    <RiCloseLine size="20px"/>
                </div>
                <div>Lorem ipsum dolor sit amet.</div>
            </div>
        </div>
    </div>
  )
}

export default Preview